module.exports = __webpack_public_path__ + "media/BUGLE.cfb74f70.mp3";